module.exports = __webpack_public_path__ + "img/ubicacion.8ad5b9b3.svg";